"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsultantSchema = exports.OConsultantWithAppointments = exports.OConsultantWithAppointmentCount = exports.OConsultant = exports.IConsultant = exports.IConsultantFilter = void 0;
const mongoose_1 = __importDefault(require("mongoose"));
const runtypes_1 = require("runtypes");
const appointments_1 = require("./appointments");
const misc_1 = require("./misc");
exports.IConsultantFilter = (0, runtypes_1.Record)({
    group: (0, runtypes_1.Optional)(runtypes_1.String),
    email: (0, runtypes_1.Optional)(runtypes_1.String),
});
exports.IConsultant = (0, runtypes_1.Record)({
    group: (0, runtypes_1.Optional)(runtypes_1.String),
    email: runtypes_1.String,
    name: runtypes_1.String,
    phone: (0, runtypes_1.Optional)(runtypes_1.String),
    organization: (0, runtypes_1.Optional)(runtypes_1.String),
    hidden: (0, runtypes_1.Optional)(runtypes_1.Boolean),
    maxAppt: (0, runtypes_1.Optional)(runtypes_1.Number),
    info: (0, runtypes_1.Optional)((0, runtypes_1.Record)({
        title: (0, runtypes_1.Optional)(runtypes_1.String),
        image: (0, runtypes_1.Optional)(runtypes_1.String),
        description: (0, runtypes_1.Optional)(runtypes_1.String),
    })),
});
exports.OConsultant = exports.IConsultant.extend({
    id: misc_1.ID,
});
exports.OConsultantWithAppointmentCount = exports.OConsultant.extend({
    numOfAppointments: runtypes_1.Number,
});
exports.OConsultantWithAppointments = exports.OConsultant.extend({
    appointments: (0, runtypes_1.Array)(appointments_1.OAppointment),
});
exports.ConsultantSchema = new mongoose_1.default.Schema({
    email: { type: String, unique: true, required: true },
    name: { type: String, required: true },
    organization: String,
    phone: String,
    group: { type: mongoose_1.default.Schema.Types.ObjectId, ref: "Group" },
    maxAppt: { type: Number, default: 1, required: true },
    hidden: { type: Boolean, default: true, required: true },
    info: { title: String, image: String, description: String },
});
